import { useState } from 'react';

const Faq = () => {
  const faqs = [
    {
      question: "What is Halo Holidays, and what services do you offer?",
      answer: "Halo Holidays is an award-winning travel company established in the UK in 2018, now expanding to the US market. We specialize in crafting unforgettable holidays, including flights, hotels, honeymoon packages, and customized travel experiences to destinations worldwide."
    },
    {
      question: "What makes Halo Holidays different from other travel companies?",
      answer: "Our tagline, 'We are here for you,' reflects our dedication to exceptional customer service. From offering exclusive deals to providing 24/7 support, we go above and beyond to ensure your travel experience is unforgettable. Plus, our recent Gold Award for the Best Small Travel Company to Southeast Asia at the British Travel Awards 2024 is a testament to our excellence."
    },
    {
      question: "Why should I choose Halo Holidays for my next trip?",
      answer: "At Halo Holidays, we pride ourselves on offering personalized service, exclusive deals, and a commitment to making travel seamless and stress-free. Our award-winning team ensures every trip is tailored to your needs, whether it's a relaxing beach holiday, a romantic honeymoon, or a family getaway."
    },
    {
      question: "Does Halo Holidays offer flexible payment options?",
      answer: "Yes, we understand the importance of flexibility in travel planning. We offer convenient deposit schemes and payment plans, allowing you to book your dream holiday with as little as a $50 deposit and pay the balance over time."
    },
    {
      question: "Can I customize my travel package with Halo Holidays?",
      answer: "Absolutely! We specialize in creating tailor-made travel experiences. Whether you're planning a honeymoon, a family adventure, or a solo trip, our travel experts will work with you to design a package that suits your preferences and budget."
    }
  ];

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="px-4 md:px-0">
      <h2 className="text-2xl font-semibold mb-4">FAQs</h2>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4 w-full">
          <div
            className={`cursor-pointer py-4 px-4 bg-white rounded-lg shadow-sm border border-light hover:shadow-md transition-shadow ${activeIndex === index ? 'pb-8' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="flex justify-between items-center">
              <h3 className="text-base md:text-lg font-medium w-[90%]">{faq.question}</h3>
              <svg
                className={`w-8 h-8 transition-transform duration-300 p-1 rounded-full text-halo-pink hover:bg-halo-pink hover:text-white focus:outline-none ${activeIndex === index ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {activeIndex === index && (
              <p className="mt-3 text-gray-700">{faq.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
